import { Radio } from 'antd';
import { Button } from '@cropler/ui-kit';
import styles from './styles.module.scss';

import { FilterParameters } from './constants/index.jsx';
import { getFilterParametersMap } from '../../utils/filter';
import { Icon as CroplerIcon } from '@cropler/ui-kit';

const MapFilterMetrics = ({ t, filterParam, onClickClose, onChangeFilterParam }) => {
  const FilterParametersMap = getFilterParametersMap(t);

  const onClose = () => {
    onClickClose();
  };
  return (
    <>
      <div className={styles.radioButtonGroupBg}></div>
      <div className={styles.radioButtonGroupWrapper}>
        <Button className={styles.radioButtonGroupClose} type="default" icon={<CroplerIcon name="close" />} onClick={onClose} />
        <Radio.Group
          defaultValue={filterParam}
          buttonStyle="solid"
          optionType="button"
          className={`${styles.radioButtonGroup}`}
          onChange={onChangeFilterParam}
        >
          {FilterParameters.map((param) => {
            const { Icon, label, id } = FilterParametersMap[param];
            return (
              <Radio.Button
                key={param}
                value={id}
                className={`${styles.radioButton} ${filterParam === param ? styles.radioButtonChecked : ''} ${param === 'bbchAI' ? 'radioButtonDarkAi' : 'radioButtonDark'}`}
              >
                <span className={styles.radioButtonText}>
                  {param === 'bbchAI' && filterParam === 'bbchAI' ? <CroplerIcon name="stageAi" /> : <Icon />}
                  {label}
                </span>
              </Radio.Button>
            );
          })}
        </Radio.Group>
      </div>
    </>
  );
};

export default MapFilterMetrics
